





























import { Component, Model, Prop, Watch, Mixins } from 'vue-property-decorator';
import {
  FitHalfScreenDialog,
  FitButton,
  FitIcon,
  FitSelectItem,
} from '@tencent/wphk-ui';
import FormMixin from '../../../common/mixins/formMixin';

interface Options {
  label: string;
  value: any;
}

@Component({
  name: 'FitSelect',
  components: {
    FitHalfScreenDialog,
    FitButton,
    FitIcon,
    FitSelectItem,
  },
})
export default class FitSelect extends Mixins(FormMixin) {
  @Prop() public title!: string;
  @Prop() public appendToBody!: boolean;
  @Prop({ default: true }) public maskClose!: boolean;
  @Prop({ default: '' }) public placeholder!: string;
  @Prop({ default: () => [] }) public items!: Options[];
  @Prop() public confirmBtnText!: string;
  @Prop() public labelFor!: string;
  @Prop() public defaultValue!: string;
  @Prop({ default: false }) public hideConfirm!: boolean;
  @Prop({ default: false }) public disabled!: boolean;
  @Model('change') public readonly value!: any;
  public curValue = '';
  public visible = false;

  @Watch('value')
  onValueChange(val) {
    this.curValue = val;
    this.notify('change', val);
  }

  public created() {
    this.$on('handleOptionClick', this.onItemChange);
    this.$on('registerItem', (callback) => {
      callback(this);
    });
    this.resetCurValue();
  }

  onClickSelect() {
    if (!this.disabled) {
      this.visible = true;
    }
  }

  // 每一个子项点击
  onItemChange(value) {
    this.curValue = value;
    if (this.hideConfirm) {
      this.$nextTick(() => {
        this.confirm();
      });
    }
  }

  // 点击确认
  public confirm() {
    if (!this.curSelectItem) {
      throw new Error('can not find current item');
    }
    this.$emit('change', this.curValue, this.curSelectItem.label);
    this.onClose();
  }


  get curSelectItem() {
    return this.items.find((item: Options) => item.value === this.curValue);
  }

  // 当前展示标签
  get curLable() {
    const curItem = this.items.find((item: Options) => item.value === this.value);
    return curItem ? curItem.label : '';
  }

  public onClose() {
    this.$emit('onClose');
    this.visible = false;
    this.resetCurValue();
  }

  // 重置当前value
  resetCurValue() {
    this.curValue = this.value || this.defaultValue;
  }
}
